import React from 'react';
import { createUseStyles } from 'react-jss';

export default function Overlay(props) {
  const { title, subtitle } = props;
  const c = useStyles(props);

  return (
    <div className={c.container}>
      <div className={c.titleContainer}>
        <div className={c.title}>{title}</div>
        <div className={c.subtitle}>{subtitle}</div>
      </div>
    </div>
  )
}

const useStyles = createUseStyles({
  container: {
    position: 'absolute',
    top: 0,
    width: '100%',
    height: '100%',
    backgroundImage: props => `url('${props.placeholderImageUrl}')`,
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    paddingLeft: '24px',
    paddingRight: '24px',
    // cover loading spinner
    zIndex: 1
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
  },
  title: {
    color: 'white',
    fontSize: '24px',
    lineHeight: '24px',
    marginBottom: '7px',
    textAlign: 'center'
  },
  subtitle: {
    color: 'rgba(201, 201, 209, 1)',
    fontSize: '16px',
    lineHeight: '24px',
    textAlign: 'center'
  },
});
